<template>
  <tr :class="['proxy', !proxy.isActive && 'error']">
    <td class="number">{{ index + 1 }}</td>
    <td class="time">{{ proxy.dateAdded }}</td>
    <td>{{ proxy.proxy }}</td>
    <td :class="['time', 'proxy-time', proxy.icetradeBannedAt && 'banned']">
      <div class="banned-cell">
        <span>{{ proxy.icetradeBannedAt }}</span>
        <button
          title="Обновить"
          type="button"
          @click.stop="$emit('refresh-proxy', proxy, 'ICE_TRADE')"
        >
          <ico name="icoRefresh" color="#79919C" />
        </button>
      </div>
    </td>
    <td :class="['time', 'proxy-time', proxy.goszakupkiBannedAt && 'banned']">
      <div class="banned-cell">
        <span>{{ proxy.goszakupkiBannedAt }}</span>
        <button
          title="Обновить"
          type="button"
          @click.stop="$emit('refresh-proxy', proxy, 'GOS_ZAKUPKI')"
        >
          <ico name="icoRefresh" color="#79919C" />
        </button>
      </div>
    </td>
    <td class="actions">
      <button
        title="Удалить"
        type="button"
        @click.stop="$emit('delete-proxy', proxy)"
      >
        <ico name="icoDelete" color="#79919C" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: "NewProxyItem",

  props: {
    proxy: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isGoszakupkiBanned() {
      return this.proxy.goszakupkiBannedAt !== null;
    },
    isIcetradeBanned() {
      return this.proxy.icetradeBannedAt !== null;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/variables.less";

.error {
  background-color: #ff7373;
}

.proxy {
  // padding: 8px 0;

  td {
    vertical-align: middle;
    border: none;
    border-bottom: 2px solid @bg-color-light;
    padding: 4px 16px;

    &.number {
      width: 80px;
    }

    &.actions {
      padding: 4px 0;
      width: 32px;

      button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
        width: 32px;
        height: 32px;

        &:last-child {
          margin-right: 0;
        }

        &:disabled {
          opacity: 0.5;
          cursor: text;
        }
      }
    }

    &.time {
      width: 170px;
    }

    &.proxy-time {
      width: 186px;
    }

    .banned-cell {
      display: none;
    }

    &.banned {
      width: 186px;
      padding: 0 4px;
      .banned-cell {
        border-radius: @br;
        background-color: #ff7373;
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: center;
        height: 41px;
      }
    }

    input {
      display: block;
      border: none;
      padding: 4px 0;
      width: 100%;

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
